"use strict";
/**
 * BroviCMS Data Models
 * Comprehensive TypeScript interfaces for the e-book CMS platform
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// User and Authentication Models
__exportStar(require("./src/user"), exports);
// Content Models (E-books, Audio, Quotes)
__exportStar(require("./src/content"), exports);
// Library and Collection Models
__exportStar(require("./src/library"), exports);
// Interaction Models (Donations, Sharing, Social)
__exportStar(require("./src/interaction"), exports);
// Firebase-specific Types
__exportStar(require("./src/firebase"), exports);
// Common Types and Utilities
__exportStar(require("./src/common"), exports);
